<div class="bg-gray-50 flex flex-col relative min-h-screen pb-24 font-prompt">

  <!-- 1. Premium Dark Gradient Header -->
  <div
    class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pb-24 pt-8 px-6 rounded-b-[2.5rem] relative z-10 text-white text-left shadow-md w-full">
    <!-- Back Button -->
    <div class="flex items-center justify-between mb-4">
      <button (click)="goback()"
        class="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 active:scale-90 transition-all outline-none">
        <img src="icons/arrow_back_white.svg" class="w-5 h-5" />
      </button>
      <span
        class="text-[10px] font-bold tracking-wider text-amber-400 bg-amber-500/10 px-3 py-1 rounded-full uppercase">
        {{ currentLang === "TH" ? "ข้อมูลสมาชิก" : "Membership info" }}
      </span>
    </div>

    <!-- Title -->
    <div class="space-y-1">
      <h1 class="text-xl font-bold leading-tight text-white">
        {{ currentLang === "TH" ? "บัตรจอดรถของคุณ" : "Your Member Card" }}
      </h1>
      <p class="text-xs text-amber-400 font-bold">
        {{ currentLang === "TH" ? "จัดการบัตรสมาชิกและทะเบียนรถเข้า-ออก" : "Manage your passes & vehicle plates" }}
      </p>
    </div>
  </div>

  <!-- 2. Floating KPI Summary Grid (Glassmorphism) -->
  <div class="px-6 -mt-16 z-20 mb-6">
    <div
      class="grid grid-cols-3 gap-3 bg-white/90 backdrop-blur-md border border-slate-100/50 rounded-3xl p-2 shadow-xl text-center">
      <div class="flex flex-col items-center py-1 group">
        <span class="text-xs font-bold text-slate-400 uppercase tracking-wider block mb-0.5">
          {{ currentLang === 'TH' ? 'บัตรทั้งหมด' : 'Total passes' }}
        </span>
        <span class="text-xl font-black text-slate-800 transition-transform group-hover:scale-110 duration-200">
          {{ totalCardsCount }}
        </span>
      </div>
      <div class="flex flex-col items-center py-1 group border-x border-slate-100">
        <span class="text-xs font-bold text-emerald-500 uppercase tracking-wider block mb-0.5">
          {{ currentLang === 'TH' ? 'ใช้งานได้' : 'Active' }}
        </span>
        <span class="text-xl font-black text-emerald-600 transition-transform group-hover:scale-110 duration-200">
          {{ activeCardsCount }}
        </span>
      </div>
      <div class="flex flex-col items-center py-1 group">
        <span class="text-xs font-bold text-rose-500 uppercase tracking-wider block mb-0.5">
          {{ currentLang === 'TH' ? 'หมดอายุ' : 'Expired' }}
        </span>
        <span class="text-xl font-black text-rose-600 transition-transform group-hover:scale-110 duration-200">
          {{ expiredCardsCount }}
        </span>
      </div>
    </div>
  </div>

  <!-- 3. Search and Category Filter Section -->
  <div class="px-6 mb-4 space-y-4">
    <!-- Search Input -->
    <div class="bg-white rounded-2xl shadow-sm border border-slate-100 p-2 flex items-center gap-2">
      <div class="pl-2 text-slate-400">
        <img src="icons/search_slate.svg" class="w-5 h-5" />
      </div>
      <input type="text" [(ngModel)]="searchText" (input)="searchCards()" placeholder="{{
            selectedCategory === 'cardName' ?
              (currentLang === 'TH' ? 'ค้นหาหมายเลขบัตร...' : 'Search card number...') :
            selectedCategory === 'siteName' ?
              (currentLang === 'TH' ? 'ค้นหาสถานที่...' : 'Search station...') :
              (currentLang === 'TH' ? 'ค้นหาประเภทบัตร...' : 'Search card type...')
        }}"
        class="w-full h-9 bg-transparent focus:outline-none text-slate-700 placeholder-slate-400 text-sm font-bold" />
      <button *ngIf="searchText" (click)="clearSearch()"
        class="w-8 h-8 flex items-center justify-center bg-slate-50 hover:bg-slate-100 rounded-xl text-slate-400 active:scale-95 transition-all outline-none">
        <img src="icons/close_slate.svg" class="w-5 h-5" />
      </button>
    </div>

    <!-- Category Tabs -->
    <div class="flex gap-2 overflow-x-auto pb-1.5 custom-scrollbar scrollbar-hide">
      <button *ngFor="let category of filterCategory" (click)="filterByCategory(category.value)"
        class="px-4 py-2 rounded-full text-xs font-bold transition-all whitespace-nowrap shadow-sm border" [ngClass]="{
          'bg-amber-400 text-slate-800 border-amber-400 shadow-amber-200/50 shadow-sm': category.value === selectedCategory,
          'bg-white text-slate-500 border-slate-100 hover:bg-slate-50': category.value !== selectedCategory
        }">
        {{ currentLang === "TH" ? category.labelTH : category.labelEN }}
      </button>
    </div>

    <p class="text-[10px] text-slate-400 font-bold px-1">
      {{ currentLang === "TH" ? "หมายเหตุ: บัตรที่หมดอายุแล้วเกิน 2 วันจะไม่แสดงในรายการ" : "Note: Expired cards older than 2 days will not be shown in the list." }}
    </p>
  </div>

  <!-- 4. Card Passes Container -->
  <div class="flex-1 px-6 space-y-3">
    <!-- Card Pass Item -->
    <div *ngFor="let card of (filteredMyCards ? filteredMyCards : myCards); let idx = index"
      (click)="openModal_option(card)"
      class="relative text-slate-800 rounded-[2rem] p-4.5 shadow-lg overflow-hidden flex items-center justify-between group hover:shadow-xl hover:scale-[1.01] transition-all duration-300 border cursor-pointer active:scale-[0.99] animate-fade-in-up"
      [ngClass]="card.isActive && !isExpired(card.expireDate)
        ? 'bg-gradient-to-r from-(--main-color) to-(--soft-color) border-white/20'
        : 'bg-slate-200 border-slate-300 opacity-85'">

      <!-- Left status bar indicator -->
      <!-- <div class="absolute left-0 top-0 bottom-0 w-1.5"
        [ngClass]="isExpired(card.expireDate) ? 'bg-rose-500' : isExpiringSoon(card.expireDate) ? 'bg-amber-500' : 'bg-emerald-500'">
      </div> -->

      <!-- Elegant circular overlay decoration on the right (matching the screenshot) -->
      <div
        class="absolute right-0 top-0 bottom-0 w-24 bg-slate-400/10 rounded-l-full pointer-events-none backdrop-blur-[1px]">
      </div>

      <div *ngIf="!card.isActive || isExpired(card.expireDate)"
        class="absolute top-0 left-0 rounded-br-2xl bg-slate-600 px-3 py-1 text-[9px] font-black text-white z-10">
        {{ currentLang === 'TH' ? 'บัตรหมดอายุแล้ว' : 'Card expired' }}
      </div>

      <!-- Left: Circular Logo (Matching the avatar) -->
      <div class="flex items-center gap-4 z-10 text-left min-w-0 flex-1">
        <div
          class="w-14 h-14 bg-white rounded-full p-2 flex items-center justify-center shadow-md flex-shrink-0 border border-slate-200/55">
          <img [src]="card.logoBase64" alt="logo" class="w-full h-full object-contain mix-blend-multiply" />
        </div>

        <!-- Middle: Title, Subtitle, and Dates -->
        <div class="min-w-0 flex-1 flex flex-col justify-center text-left">
          <div class="flex items-center gap-2 mb-1 pr-1.5 flex-wrap">
            <h3
              class="text-xs font-black tracking-wide leading-tight line-clamp-1 text-slate-800 flex items-center gap-1">
              {{ card.myVehicles.length ? card.myVehicles[0].plateNumber : (currentLang === 'TH' ? 'โปรดระบุทะเบียน' :
              'Assign Plate') }}
              <span *ngIf="card.myVehicles.length" class="text-[9px] text-slate-500 font-bold">
                ({{ card.myVehicles[0].province }})
              </span>
            </h3>

            <!-- Status Badge (moved here directly following the plate text) -->
            <span class="text-[8px] font-black uppercase px-2 py-0.5 rounded-full leading-none shrink-0"
              [ngClass]="!card.isActive || isExpired(card.expireDate) ? 'bg-slate-300 text-slate-700' : isExpiringSoon(card.expireDate) ? 'bg-amber-100 text-amber-600' : 'bg-emerald-100 text-emerald-600'">
              {{ !card.isActive || isExpired(card.expireDate) ? (currentLang === 'TH' ? 'หมดอายุ' : 'Expired') :
              isExpiringSoon(card.expireDate) ? (currentLang === 'TH' ? 'เตือน' : 'Soon') : (currentLang === 'TH' ?
              'ใช้งาน' : 'Active') }}
            </span>
          </div>

          <p class="text-[10px] text-slate-600 font-bold line-clamp-1 mb-2">
            {{ card.siteName }}
          </p>

          <!-- Dates in horizontal grid (Followers/Likes style) -->
          <div class="flex items-center gap-3 text-[9px] text-slate-500 font-bold tracking-wide">
            <div>
              <span class="block text-slate-500 text-[9px] uppercase tracking-wider mb-0.5 leading-none">
                <img src="icons/credit_card_black.svg" class="w-5 h-5" />
                {{ currentLang === "TH" ? "หมายเลขบัตร" : "Card No." }}
              </span>
              <span class="font-mono text-slate-700 font-bold text-[10px]">{{ card.cardName }}</span>
            </div>
            <div class="w-[1px] h-3.5 bg-slate-400/30"></div>
            <div>
              <span class="block text-rose-600 text-[9px] uppercase tracking-wider mb-0.5 leading-none">
                <img src="icons/calendar_today_red.svg" class="w-5 h-5" />
                {{ currentLang === "TH" ? "วันหมดอายุ" : "Expiry" }}
              </span>
              <span class="font-mono text-rose-600 font-bold text-[10px]">
                {{ card.expireDate | date : "dd/MM/yyyy HH:mm" }} น.
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Side: Circular highlighted shape containing Actions -->
      <div
        class="z-10 flex flex-col items-center justify-between shrink-0 self-stretch pb-1 pl-4 w-[35px] text-right relative">
        <!-- Bottom row: Chevron -->
        <div class="mt-auto mb-1">
          <img src="icons/chevron_right_black.svg" class="w-5 h-5" />
        </div>
      </div>

      <!-- Top row: Copy button & Vehicle Type Icon side by side -->
      <div class="flex items-center absolute top-3 right-4 gap-2 z-20">
        <button (click)="copyToClipboard(card.cardName); $event.stopPropagation()"
          class="text-slate-600 hover:text-amber-600 transition-colors ">
          <img src="icons/content_copy_black.svg" class="w-5 h-5" />
        </button>

        <div class="">
          <img src="{{ card.vehicleTypeId === 1 ? 'icons/directions_car_black.svg' : 'icons/motorcycle_black.svg' }}"
            class="w-5 h-5" />
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && myCards.length === 0"
      class="flex flex-col items-center justify-center py-20 text-slate-400">
      <i class="fa fa-credit-card text-5xl opacity-40 mb-2"></i>
      <p class="text-xs font-bold">{{ currentLang === "TH"
        ? "ไม่พบบัตรจอดรถของคุณ"
        : "Your parking card was not found."
        }}</p>
    </div>
  </div>
</div>

<!-- Premium Fullscreen Loading Overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>

<!-- MODAL: Options Menu (Settings Option) -->
<div *ngIf="showModal_option"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 text-center animate-fade-in">
  <div class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-sm relative overflow-hidden animate-scale-up">
    <!-- Close Button -->
    <button (click)="closeModal_option()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-slate-50 hover:bg-slate-100 text-slate-400 hover:text-rose-500 transition-colors flex items-center justify-center outline-none">
      <img src="icons/close_slate_dark.svg" class="w-5 h-5" />
    </button>

    <div class="pt-8 pb-5 flex flex-col items-center px-4">
      <img src="icons/PSS/PSS Sticker-01.png" alt="pss" class="w-16 h-16 object-contain mb-3 drop-shadow-md">
      <h3 class="text-sm font-bold text-slate-800">
        {{ currentLang === "TH" ? "ตัวเลือกการจัดการบัตร" : "Manage Member Card" }}
      </h3>
      <p class="text-[10px] text-slate-400 font-bold mt-0.5">
        {{ currentLang === "TH" ? "เลือกรายการที่คุณต้องการดำเนินการ" : "Please select an action below" }}
      </p>
    </div>

    <div class="px-4 pb-6 space-y-2.5">
      <!-- QR Button -->
      <button (click)="openListLicense(selectedCard!); closeModal_option()"
        class="w-full flex items-center gap-3 p-3 rounded-2xl bg-amber-50 hover:bg-amber-100/70 border border-amber-100 text-left transition-colors outline-none active:scale-[0.98]">
        <div class="w-8 h-8 rounded-xl bg-amber-400 text-slate-800 flex items-center justify-center">
          <img src="icons/qr_code_2_black.svg" class="w-5 h-5" />
        </div>
        <div class="min-w-0">
          <h4 class="text-xs font-bold text-slate-800">
            {{ currentLang === "TH" ? "แสดง QR สแกนเข้า/ออก" : "Show QR Pass" }}
          </h4>
          <p class="text-[9px] text-slate-400 font-bold mt-0.5">
            {{ currentLang === "TH" ? "สแกนเพื่อเปิดไม้กั้น" : "Scan to open gate" }}
          </p>
        </div>
      </button>

      <!-- Renewal Button -->
      <button (click)="openRenewal(selectedCard!); closeModal_option()"
        class="w-full flex items-center gap-3 p-3 rounded-2xl bg-slate-50 hover:bg-slate-100 border border-slate-100 text-left transition-colors outline-none active:scale-[0.98]">
        <div class="w-8 h-8 rounded-xl bg-slate-800 text-white flex items-center justify-center">
          <img src="icons/autorenew_white.svg" class="w-5 h-5" />
        </div>
        <div class="min-w-0">
          <h4 class="text-xs font-bold text-slate-800">
            {{ currentLang === "TH" ? "ต่ออายุบัตรจอดรถ" : "Renew Pass" }}
          </h4>
          <p class="text-[9px] text-slate-400 font-bold mt-0.5">
            {{ currentLang === "TH" ? "ชำระค่าบริการรายเดือนเพิ่ม" : "Pay for next billing cycle" }}
          </p>
        </div>
      </button>

      <!-- Settings Button -->
      <button (click)="openManageCard(selectedCard!); closeModal_option()"
        class="w-full flex items-center gap-3 p-3 rounded-2xl bg-slate-50 hover:bg-slate-100 border border-slate-100 text-left transition-colors outline-none active:scale-[0.98]">
        <div class="w-8 h-8 rounded-xl bg-slate-200 text-slate-600 flex items-center justify-center">
          <img src="icons/settings_slate_dark_soft.svg" class="w-full h-full" />
        </div>
        <div class="min-w-0">
          <h4 class="text-xs font-bold text-slate-800">
            {{ currentLang === "TH" ? "เปลี่ยนทะเบียนรถ" : "Change Vehicle Plate" }}
          </h4>
          <p class="text-[9px] text-slate-400 font-bold mt-0.5">
            {{ currentLang === "TH" ? "แก้ไขข้อมูลทะเบียนรถผูกบัตร" : "Update license plate settings" }}
          </p>
        </div>
      </button>
    </div>
  </div>
</div>

<!-- MODAL: QR Code Display -->
<div *ngIf="isModalOpen"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4 text-center animate-fade-in">
  <div
    class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-sm relative overflow-visible mt-10 p-6 animate-scale-up">
    <!-- Portrait Icon Header -->
    <div
      class="absolute -top-10 left-1/2 transform -translate-x-1/2 w-20 h-20 bg-white rounded-full p-4 shadow-lg flex items-center justify-center border-4 border-amber-400">
      <img src="icons/qr_code_scanner_orange.svg" class="w-full h-full" />
    </div>

    <!-- Close Button -->
    <button (click)="closeModal()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-slate-50 hover:bg-slate-100 text-slate-400 hover:text-black transition-all flex items-center justify-center outline-none">
      <img src="icons/close_slate_dark.svg" class="w-5 h-5" />
    </button>

    <div class="pt-8">
      <h2 class="text-sm font-black text-slate-800 mb-0.5">
        {{ currentLang === "TH" ? "QR บัตรสมาชิกจอดรถ" : "Parking Card QR" }}
      </h2>
      <p class="text-[10px] text-slate-400 font-bold mb-4">
        {{ currentLang === "TH" ? "ใช้สำหรับสแกนเข้า/ออก ช่องทางจอดรถ" : "Scan to enter/exit member parking" }}
      </p>

      <!-- QR Box Wrapper -->
      <div
        class="bg-white border-2 border-dashed border-slate-200 rounded-3xl p-4 inline-block mb-4 shadow-inner relative overflow-hidden">
        <img *ngIf="isBase64Image(obfuscatedCode)" [src]="getQrImageSrc(obfuscatedCode)" alt="QR Code"
          class="w-48 h-48 object-contain mx-auto rounded-xl" />
        <qrcode *ngIf="!isBase64Image(obfuscatedCode)" [qrdata]="obfuscatedCode" [width]="180"
          [errorCorrectionLevel]="'M'"></qrcode>
      </div>

      <!-- Card details metadata table -->
      <div class="bg-slate-50 rounded-2xl p-4 text-left space-y-2.5 text-xs border border-slate-100">
        <div class="flex justify-between items-center">
          <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "ป้ายทะเบียน" : "License Plate" }}</span>
          <span
            class="font-black text-slate-800 bg-white border border-slate-300 rounded px-2 py-0.5 shadow-sm font-mono">{{
            selectedLicensePlate }}</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "อาคารจอดรถ" : "Location" }}</span>
          <span class="font-bold text-slate-800 truncate max-w-[180px]">{{ selectedCard?.siteName }}</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "วันหมดอายุสมาชิก" : "Expiry Date" }}</span>
          <span class="font-bold text-rose-500">{{ selectedCard?.expireDate | date : "dd/MM/yyyy HH:mm" }}</span>
        </div>
      </div>

      <!-- Expiry Warning -->
      <p class="text-[9px] text-rose-500 mt-4 flex items-center justify-center gap-1 font-bold">
        <img src="icons/info_red.svg" class="w-6 h-6" />
        {{ currentLang === "TH" ? "รหัส QR มีอายุใช้งาน 10 นาทีเพื่อความปลอดภัย" : "QR code is valid for 10 minutes for
        safety" }}
      </p>

      <!-- Bottom Button -->
      <button (click)="closeModal()"
        class="mt-6 w-full py-3.5 bg-slate-900 text-white font-black rounded-2xl hover:bg-slate-800 active:scale-95 transition-all text-xs outline-none">
        {{ currentLang === "TH" ? "เสร็จสิ้น" : "Done" }}
      </button>
    </div>
  </div>
</div>

<!-- MODAL: License Plate Selection (when card has multiple plates) -->
<div *ngIf="isModalLicenseOpen"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 text-center animate-fade-in">
  <div class="bg-white rounded-3xl shadow-2xl w-full max-w-xs overflow-hidden animate-scale-up">
    <!-- Header -->
    <div class="bg-slate-900 p-4 text-left relative flex justify-between items-center">
      <h2 class="text-sm font-bold text-white leading-none">
        {{ currentLang === "TH" ? "เลือกทะเบียนสแกนผ่านทาง" : "Select Plate to Scan" }}
      </h2>
      <button
        class="w-6 h-6 rounded-full bg-white/10 text-white hover:bg-white/20 flex items-center justify-center outline-none active:scale-90 transition-all"
        (click)="isModalLicenseOpen = false">
        <img src="icons/close_slate_dark.svg" class="w-5 h-5" />
      </button>
    </div>

    <!-- Scrollable list of plates -->
    <div class="max-h-60 overflow-y-auto p-3 custom-scrollbar">
      <div class="space-y-2">
        <div *ngFor="let plate of licensePlates" (click)="selectPlate(plate)"
          class="px-4 py-3 cursor-pointer rounded-2xl border transition-all flex justify-between items-center"
          [ngClass]="plate.plate_number === selectedLicensePlate ? 'bg-amber-500/10 border-amber-300' : 'bg-slate-50 border-slate-100 hover:bg-slate-100'">
          <span class="font-black text-slate-800 text-sm">{{ plate.plate_number }}</span>
          <span class="text-[10px] text-slate-400 font-bold">{{ plate.province_name }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Custom settings card popup component integration -->
<app-setting-mycard-modal [isOpen]="isManageModalOpen" [card]="selectedCard" (close)="closeManageCard()"
  (requestChangePlate)="onRequestChangePlate($event)"></app-setting-mycard-modal>
